<template>
  <div style="color: #fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height: 100%; width: 100%">
        <div class="panel margin--bottom">
          <bar-card :bg="'border10'">
            <!-- <div class="closeDraw">
              <el-button icon="el-icon-close"
                         @click="closeClick"></el-button>
            </div> -->
            <div class="cardContentT">
              <v-title :item="sjObj">{{ sjObj.name }}</v-title>
              <div class="chart" ref="chart" />
            </div>
            <div class="cardContents">
              <v-title :item="srObj">{{ srObj.name }}</v-title>
              <div class="chart" ref="lineChart" />
            </div>
            <div class="cardContent1">
              <v-title :item="fxObj">{{ fxObj.name }}</v-title>
              <div class="chart" ref="circleChart"></div>
            </div>
          </bar-card>
        </div>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import { loadChart } from "./chart/chartData";
import { loadLineChart } from "./chart/lineChart";
import { loadCircleChart } from "./chart/circleChart";
import {
  getOrgProcessByOrgIdGetMNSR,
  getOrgProcessGetLNDNALL,
  getOrgProcessOrgALLDDNH
} from "@/api/base";
import { mapGetters } from "vuex";
// import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
export default {
  components: {
    // videoPlayer
  },
  computed: {
    ...mapGetters(["graphic"])
  },
  data() {
    return {
      sjObj: {
        name: "数据指标",
        hasBtn: true
      },
      srObj: {
        name: "人均可支配收入",
        hasBtn: false
      },
      fxObj: {
        name: "企业联农带农效益分析",
        hasBtn: false
      },
      chart: null,
      lineChart: null,
      circleChart: null,
      from: {},
      playerOptionm: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src:
              "http://14.29.246.119:9007/upload/媒体报道视频/“菠萝猪”：农民致富路上的“甜蜜事业”.mp4" // url地址
          }
        ],
        poster:
          "http://14.29.246.119:9007/upload/project/“菠萝猪”：农民致富路上的“甜蜜事业”.png", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      }
    };
  },
  mounted() {
    this.initChart();
    if (this.graphic) {
      this.from = this.graphic;
      this.loadChartData(this.from.id);
    } else {
      this.loadChartData();
    }
  },
  watch: {
    graphic(val) {
      if (val) {
        this.from = val;
        this.loadChartData(val.id);
      }
    }
  },
  methods: {
    closeClick() {
      this.$store.dispatch("drawer/setRightComponent", "rightDrawer");
      this.$store.dispatch("drawer/setGraphic", null);
    },
    initChart() {
      this.chart = this.$echarts.init(this.$refs.chart);
      this.lineChart = this.$echarts.init(this.$refs.lineChart);
      this.circleChart = this.$echarts.init(this.$refs.circleChart);
      window.addEventListener("resize", () => {
        this.chart.resize();
        this.lineChart.resize();
        this.circleChart.resize();
      });
    },
    loadChartData(id) {
      getOrgProcessGetLNDNALL({ orgId: id }).then(res => {
        if (res.code === 200 && JSON.stringify(res.data) != "{}") {
          let data = [
            {
              name: "带动农户",
              value: res.data.ddnh
            },
            {
              name: "紧密型",
              value: res.data.ddnh_jmx
            },
            {
              name: "松散型",
              value: res.data.ddnh_ssx
            },
            {
              name: "辐射型",
              value: res.data.ddnh_fsx
            },
            {
              name: "带动贫困人口",
              value: res.data.ddnh_pk
            }
          ];
          loadChart(this.chart, data);
        } else {
          this.chart.clear();
        }
      });
      getOrgProcessByOrgIdGetMNSR({ orgId: id }).then(res => {
        console.log("res.data", JSON.stringify(res.data));
        res.data = [
          { qxrjsr: 17800, yqrjsr: 21000, year: 2019 },
          { year: 2020, qxrjsr: 18000, yqrjsr: 21500 },
          { year: 2021, yqrjsr: 26000, qxrjsr: 19000 }
        ];
        if (res.code === 200 && res.data.length > 0) {
          let fontSizes;
          if (document.documentElement.offsetWidth <= 1280) {
            fontSizes = 10;
            if (this.from) {
              loadLineChart(
                this.lineChart,
                res.data,
                res.ValveData,
                this.from.sname,
                fontSizes
              );
            } else {
              loadLineChart(
                this.lineChart,
                res.data,
                res.ValveData,
                "",
                fontSizes
              );
            }
          } else {
            fontSizes = 13;
            if (this.from) {
              loadLineChart(
                this.lineChart,
                res.data,
                res.ValveData,
                this.from.sname,
                fontSizes
              );
            } else {
              loadLineChart(
                this.lineChart,
                res.data,
                res.ValveData,
                "",
                fontSizes
              );
            }
          }
        } else {
          this.lineChart.clear();
        }
      });
      getOrgProcessOrgALLDDNH({ id }).then(res => {
        if (res.code === 200) {
          let fontSizes;
          let widths;
          let itemGaps;
          if (document.documentElement.offsetWidth <= 1280) {
            fontSizes = 8;
            widths = 6;
            itemGaps = 1;
            loadCircleChart(
              this.circleChart,
              res.data,
              fontSizes,
              widths,
              itemGaps
            );
          } else {
            fontSizes = 13;
            widths = 10;
            itemGaps = 10;
            loadCircleChart(
              this.circleChart,
              res.data,
              fontSizes,
              widths,
              itemGaps
            );
          }
        }
      });
    }
  },
  destroyed() {
    this.chart.dispose();
    this.lineChart.dispose();
    this.circleChart.dispose();
  }
};
</script>

<style lang="stylus" scoped>
.videobox
  height calc(100% - 8px)
  margin-bottom 8px
  width calc(100% - 0px)
  border-radius 10px
.cardContentT
  height 33%
  .chart
    height calc(100% - 38px)
.cardContent1
  height 33%
  .chart
    height calc(100% - 38px)
// .cardContent
//   height 35%
//   .chart
//     height calc(100% - 38px)
.cardContents
  height 34%
  .chart
    height calc(100% - 38px)
.panel
  height calc(100% - 8px)
  width 100%
  font-size 0.06rem
  position relative
.closeDraw
  position absolute
  right 10px
  top 10px
  .el-button
    background transparent
    color #fff
    font-size 25px
    padding 0
    border 0
    position relative
.imgs
  height calc(100% - 38px)
  width calc(100% - 20px)
  padding 0 10px
  text-align center
  justify-content center
  >img
    width 100%
    height 100%
@media (max-width 1280px)
  .content
    height calc(100% - 25px)
  .imgs
    height calc(100% - 25px)
  .closeDraw
    top 5px
    .el-button
      font-size 15px
  .cardContentT
    height 24%
    .chart
      height calc(100% - 25px)
  .cardContent1
    height 19%
    .chart
      height calc(100% - 25px)
  .cardContent
    height 30%
    .chart
      height calc(100% - 25px)
  .cardContents
    height 27%
    .chart
      height calc(100% - 25px)
</style>
<style>
.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  height: 100% !important;
  padding-top: 0 !important;
  width: 100% !important;
}
.vjs-tech {
  width: 100% !important;
  height: 100% !important;
}
.vjs-poster {
  background-position: center !important;
  background-size: cover !important;
}
.dddd {
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: fill;
  border: 1px #31d5f3 solid;
}
video {
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  border: 1px #31d5f3 solid;
}
/* video{
      width: 100% !important;
      height: calc(100vh - 95px) !important;
      object-fit:fill;    //消除留白
} */
</style>
